export default "__VITE_ASSET__DUk$WRe3__"